import moment from 'moment'

function selectRender (data, options) {
  const option = options.find(option => option.value === data)
  return option ? option.label : ''
}

function multiselectRender (data, options) {
  return data.map(value => {
    const item = options.find(option => option.value === value)
    return item ? item.label : ''
  }).join(',')
}

function timeRender (data, dateType) {
  return data ? moment(data).format(dateType) : '-'
}

function customRender (data, column, full, index) {
  return column.customRender(data, full, index)
}

function itemRender (data, column, full, index) {
  if (!data || data === undefined && column.type !== 'custom') {
    return ''
  }
  if (!column.type) {
    return data
  }
  if (column.type === 'select') {
    return selectRender(data, column.options)
  } else if (column.type === 'multiselect') {
    return multiselectRender(data, column.options)
  } else if (column.type === 'time') {
    return timeRender(data, column.dateType || 'YYYY-MM-DD HH:mm:ss')
  } else if (column.type === 'custom') {
    return customRender(data, column, full, index)
  } else {
    return data
  }
}

export function infoRender (data, column, full, index) {
  const result = itemRender(data, column, full, index)
  return result === '' ? '-' : result
}



// WEBPACK FOOTER //
// ./src/components/InfoRender/infoRender.js